/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RestructuringRequestResult } from './restructuring-request-result';
import { RestructuringWorkflowSettingsLight } from './restructuring-workflow-settings-light';
import { RestructuringLetter } from './restructuring-letter';
import { RestructuringEmployeeSnapshotLight } from './restructuring-employee-snapshot-light';
import { UsersUsersUser } from './users-users-user';
import { RestructuringEmployee } from './restructuring-employee';

export interface RestructuringRequest {
  id?: string;
  employeeSnapshotId?: string;
  employeeId?: string;
  seasonId?: string;
  seasonTitle?: string | null;
  planId?: string;
  planTitle?: string | null;
  employeeSnapshot: RestructuringEmployeeSnapshotLight;
  createdBy?: RestructuringEmployee;
  updatedBy?: UsersUsersUser;
  createdAt?: string | null;
  updatedAt?: string | null;
  state?: RestructuringRequestStateEnum;
  fiscalYear: string | null;
  isFrozen?: boolean;
  result?: Array<RestructuringRequestResult> | null;
  reason?: string | null;
  subState?: string | null;
  possibleStates?: Array<RestructuringWorkflowSettingsLight> | null;
  country?: string | null;
  legalEntity?: string | null;
  isLetterCreated?: boolean | null;
  isCalculationLetterCreated?: boolean | null;
  letter?: RestructuringLetter;
  calculationLetter?: RestructuringLetter;
}
export enum RestructuringRequestStateEnum {
  Draft = 'Draft',
  Monitoring = 'Monitoring',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Published = 'Published'
}
